import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { AxiosConfiguration } from "../../Utils/AxiosConfig";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  generate_company_ID,
  get_Date,
  getDataArr,
} from "../../Utils/commonFunctions";
import { MultiSelect } from "react-multi-select-component";
import { useDispatch } from "react-redux";
import { fillListManufacturerData } from "../../redux/Admin/listManufacturer";
import dataTableGrid from "../DataTableGrid";
import {
  SelectorListManufaturers,
  SelectorDropdownManufaturers,
  SelectorDeleteID,
  SelectorSelected,
} from "../../redux/Admin/selectorManufacturer";

let AdminListManufacturer = () => {
  const dispatch = useDispatch();
  const selectors = {
    listManufaturers: SelectorListManufaturers(),
    dropdownManufaturers: SelectorDropdownManufaturers(),
    deleteID: SelectorDeleteID(),
    selected: SelectorSelected(),
  };
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    manage_manufacturer();
  }, []);
  const manage_manufacturer = async () => {
    let axios_instance = AxiosConfiguration();
    let selectedArr = getDataArr(selected);
    const bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", selectedArr);
    await axios_instance
      .post("v1/manufacturer_list/", bodyFormData)
      .then((response) => {
        if (response.data.data.length > 0) {
          let optionItems = response.data.data.map((item, i) => (
            <tr key={++i}>
              <td>{++i}</td>
              <td>
                <img className="listImage" src={item.company_logo} />
              </td>
              <td>{generate_company_ID(item.manufacturer_id)}</td>
              <td>{item.company_name}</td>
              <td>{item.country__country_name}</td>
              <td>{get_Date(item.created_date)}</td>
              <td>
                <Link
                  to={"/AdminListSites/" + item.manufacturer_id}
                  className="btn btn-sm custom-btn-primary"
                >
                  Sites
                </Link>{" "}
                &nbsp;
                <Link
                  to={"/AdminListUsers/" + item.manufacturer_id}
                  className="btn btn-sm custom-btn-primary"
                >
                  Users
                </Link>{" "}
                &nbsp;
                {item.can_be_deleted === "yes" ? (
                  <button
                    className="btn btn-sm btn-danger"
                    data-toggle="modal"
                    data-target="#modal-default"
                    onClick={() => {
                      dispatch(
                        fillListManufacturerData({
                          fieldName: "deleteID",
                          value: item.manufacturer_id,
                        })
                      );
                    }}
                  >
                    {" "}
                    <i className="fa fa-trash"></i>
                  </button>
                ) : (
                  <button className="btn btn-sm btn-danger" disabled>
                    {" "}
                    <i className="fa fa-trash"></i>
                  </button>
                )}
              </td>
            </tr>
          ));
          dispatch(
            fillListManufacturerData({
              fieldName: "listManufaturers",
              value: optionItems,
            })
          );
          dataTableGrid({
            data_table_id: "#ListManufacturer",
            paginate: false,
            copy_option: [0, 3, 4, 5],
            csv_option: [0, 3, 4, 5],
            print_option: [0, 3, 4, 5],
            sort_option: [6],
          });
        } else {
          const getMessage = (
            <tr>
              <td colSpan={7}> {response.data.message}</td>
            </tr>
          );
          dispatch(
            fillListManufacturerData({
              fieldName: "listManufaturers",
              value: getMessage,
            })
          );
        }
      })
      .catch((error) => {
        toast.error("Something went wrong try again", { autoClose: 1500 });
      });
  };

  const handleDeleteRecord = async () => {
    let axios_instance = AxiosConfiguration();
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_id", selectors.deleteID);
    await axios_instance
      .post("v1/delete_manufacturer/", bodyFormData)
      .then((response) => {
        if (response.data.status === "success") {
          toast.success(response.data.message, { autoClose: 1500 });
          document.getElementById("close_modal").click();
          manage_manufacturer();
        } else {
          toast.warning(response.data.message, { autoClose: 1500 });
          document.getElementById("close_modal").click();
        }
      })
      .catch((error) => {
        toast.error("Something went wrong please try again", {
          autoClose: 1500,
        });
        document.getElementById("close_modal").click();
      });
  };

  useEffect(() => {
    async function fetchMyAPI_dropdown() {
      let axios_instance = AxiosConfiguration();
      await axios_instance
        .post("v1/get_manufacturer/")
        .then((response) => {
          if (response.data.data) {
            const tmpValue = [];
            response.data.data.map((item) =>
              tmpValue.push({
                label: item.company_name,
                value: item.manufacturer_id,
              })
            );
            dispatch(
              fillListManufacturerData({
                fieldName: "dropdownManufaturers",
                value: tmpValue,
              })
            );
          }
        })
        .catch((error) => {
          toast.error("Something went wrong try again", { autoClose: 1500 });
        });
    }
    fetchMyAPI_dropdown();
  }, []);

  const filterCompanyName = async () => {
    if (selected.length === 0) {
      return false;
    }
    manage_manufacturer();
  };
  let refreshCompanyName = () => {
    setSelected([]);
    selected.length = 0;
    manage_manufacturer();
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-default" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteRecord()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-4">
                            <MultiSelect
                              options={selectors.dropdownManufaturers}
                              value={selected}
                              onChange={setSelected}
                              labelledBy="Select"
                              //closeOnChangedValue="true"
                            />
                          </div>
                          <div className="col-md-2">
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => filterCompanyName()}
                            >
                              <i className="fa fa-search" aria-hidden="true" />{" "}
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => refreshCompanyName()}
                            >
                              <i className="fa fa-refresh" aria-hidden="true" />{" "}
                            </button>
                          </div>
                          <div className="col-md-6">
                            <h3 className="card-title card-header-link pull-right ">
                              <Link
                                to="/AdminAddManufacturer"
                                className="custom-link-primary"
                              >
                                <b>+ Add Manufacturer</b>
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="ListManufacturer"
                          className="table table-bordered table-striped example1"
                        >
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Company Logo</th>
                              <th>Company ID</th>
                              <th>Company Name</th>
                              <th>Country</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{selectors.listManufaturers}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};
export default AdminListManufacturer;
